import { getIssueMPMethods } from "../../Common/services/mileposts";
import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";

export const UtilFunctions = {
  getLastInspectionDate: (Maintenance) => {
    const { executionData } = Maintenance;
    if (!executionData) return null;
    let x = executionData.sort((a, b) => {
      let aDate = a.date;
      let bDate = b.date;
      return new Date(bDate) - new Date(aDate);
    });
    return x[0] && x[0].date ? x[0].date : null;
  },
  getLastInspectionUser: (Maintenance) => {
    const { executionData } = Maintenance;
    if (!executionData) return Maintenance.createdBy;
    let x = executionData.sort((a, b) => {
      let aDate = a.date;
      let bDate = b.date;
      return new Date(bDate) - new Date(aDate);
    });
    return x[0] && x[0].user ? x[0].user.name : null;
  },

  sortDates: (dates) => {
    return dates.sort((a, b) => new Date(b) - new Date(a));
  },
  getMPS: (m, m1) => {
    let startMarker = getIssueMPMethods.getIssueMarkerStart(m1.issue);
    let endMarker = getIssueMPMethods.getIssueMarkerEnd(m1.issue);
    let mExecMPStartPrefix = LocPrefixService.getPrefixMp(m.startMp, m1.lineId);
    let mExecMPEndPrefix = LocPrefixService.getPrefixMp(m.endMp, m1.lineId);
    let startMp = m.startMp
      ? `${mExecMPStartPrefix} ${m.startMp}`
      : startMarker || endMarker
      ? startMarker || "N/A"
      : getIssueMPMethods.getIssueFinalStartMP(m1.issue, m1.lineId, true);
    let endMp = m.endMp
      ? `${mExecMPEndPrefix} ${m.endMp}`
      : startMarker || endMarker
      ? endMarker || "N/A"
      : getIssueMPMethods.getIssueFinalEndMP(m1.issue, m1.lineId, true);
    return { startMp, endMp };
  },
  formatDate: (date) => {
    const formattedDate = new Date(date).toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return formattedDate;
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/WorkOrderReport/CommonUtilFunction.js